import PlayIcon from '@/modules/Education/assets/icons/play.svg?react';
import { useState } from 'react';
import { Box } from 'styled-system/jsx';
import VoicePlayer from '../VoicePlayer';
import { AudioMediaProps } from '@/modules/Education/types/Education.type';

export default function AudioMedia({ src, cover, title }: AudioMediaProps) {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <Box width="100%" height="100%" position="relative">
      <img
        src={cover}
        alt={title}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />

      {isPlaying ? (
        <Box position="absolute" bottom="0" left="0" right="0" zIndex="1">
          <VoicePlayer src={src} autoPlay />
        </Box>
      ) : (
        <>
          <Box position="absolute" inset="0" bg="rgba(0,0,0,0.15)" />
          <Box
            onClick={() => setIsPlaying(true)}
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="56px"
            height="56px"
            borderRadius="full"
            cursor="pointer"
            zIndex="1"
          >
            <PlayIcon />
          </Box>
        </>
      )}
    </Box>
  );
}
